import { render } from "./complete.vue?vue&type=template&id=5b2e3548&scoped=true"
import script from "./complete.vue?vue&type=script&lang=js"
export * from "./complete.vue?vue&type=script&lang=js"

import "./complete.vue?vue&type=style&index=0&id=5b2e3548&lang=scss&scoped=true"

import exportComponent from "D:\\jll-web-xintan\\xinfu-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b2e3548"]])

export default __exports__